import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SendInviteEmailMutationVariables = Types.Exact<{
  accountUserId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  membershipId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SendInviteEmailMutation = { __typename?: 'Mutation', sendInviteEmail?: { __typename?: 'SendInviteEmailPayload', membership?: { __typename?: 'Membership', id: string } | null } | null };


export const SendInviteEmail = /*#__PURE__*/ gql`
    mutation SendInviteEmail($accountUserId: ID, $membershipId: String) {
  sendInviteEmail(
    input: {accountUserId: $accountUserId, membershipId: $membershipId}
  ) {
    membership {
      id
    }
  }
}
    ` as unknown as DocumentNode<SendInviteEmailMutation, SendInviteEmailMutationVariables>;

          

          export const useSendInviteEmailMutation = (options?:MutationHookOptions<SendInviteEmailMutation, SendInviteEmailMutationVariables>) => useMutation(SendInviteEmail, options);
          

          export type SendInviteEmailMutationOptions = MutationHookOptions<SendInviteEmailMutation, SendInviteEmailMutationVariables>;

          

          export type SendInviteEmailMutationResult = ReturnType<typeof useSendInviteEmailMutation>[1];

          
